import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'nominas/registro_presupuestal_ipejal';

/**
 * GET IPEJAL Registro Presupuestales
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getRegistrosPresupuestalesIPEJAL = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET IPEJAL Registro Presupuestales
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getRegistroPresupuestalIPEJAL = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST IPEJAL Registro Presupuestal
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postRegistroPresupuestalIPEJAL = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH IPEJAL Registro Presupuestal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchRegistroPresupuestalIPEJAL = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE IPEJAL Registro Presupuestal
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteRegistroPresupuestalIPEJAL = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR IPEJAL Registro Presupuestal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarRegistroPresupuestalIPEJAL = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
